import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../../lib/react-query";
import { getUsers } from "../api/usersAPI";
import { RootState } from "../../../../redux/store";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getUsers;

type UseSearchUsersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useSearchUsers = ({ config }: UseSearchUsersOptions = {}) => {
    const userFilters = useSelector((state: RootState) => state.historical.user);
    const onlyActive = useSelector((state: RootState) => state.filters.users.filterByOnlyActiveRecords);
    const historical = useSelector((state: RootState) => state.historical.roles);

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: ['getUsers', userFilters, onlyActive, historical.currentPage, historical.itemsPerPage],
    queryFn: () => getUsers({
        pageNumber: userFilters.currentPage,
        pageSize: userFilters.itemsPerPage,
        search: userFilters.searchText,
        filterByOnlyActiveRecords: onlyActive,
        selectedOrganizationalStructureIds: []
    }),
  });
}